import React from 'react';
import useBetaVersion from '@hooks/useBetaVersion/useBetaVersion.tsx';
import { BetaSurface } from '@hooks/useBetaVersion/betaSurfaces.ts';
import LegacyNotificationMenuItem from '@app/layout/LegacyNotificationMenuItem.tsx';
import NotificationCenterMenuItem from '@app/layout/NotificationCenterMenuItem.tsx';

interface ComponentProps {
  /** Render as the icon rail. */
  smallMenu?: boolean;
}

/**
 * Badge + preview panel for notifications, in the version the NOTIFICATION_CENTER beta surface
 * resolves to. The switch itself lives only on the notifications page — this follows whatever the
 * user picked there (the stored override broadcasts, so the menu updates without a reload).
 */
const NotificationMenuItem: React.FC<ComponentProps> = ({ smallMenu }) => {
  const { showLegacy } = useBetaVersion(BetaSurface.NOTIFICATION_CENTER);

  return showLegacy ? <LegacyNotificationMenuItem smallMenu={smallMenu} /> : <NotificationCenterMenuItem smallMenu={smallMenu} />;
};

export default NotificationMenuItem;